import dayjs from "dayjs";

export const getAgeFromDateOfBirth = (dateOfBirth: string): number => {
  const formattedDayOfBirth = dayjs(dateOfBirth);
  const dateNow = dayjs();
  return dateNow.diff(formattedDayOfBirth, "year");
};
